<template>
  <v-container justify-center fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <v-card class="ma-1">
          <v-toolbar color="#0044a3" dark>
            <v-app-bar-nav-icon><v-icon large>mdi-account-group</v-icon></v-app-bar-nav-icon>
            <v-toolbar-title class="white--text">{{
              $t("automazione-assignments-title")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-data-table
              :items="assistants"
              :headers="headers"
              dense
              :loading="loading"
              item-key="id"
              :items-per-page="10"
            >
              <template v-slot:item.target_list_id="{ item }">
                <v-select
                  outlined
                  dense
                  hide-details
                  :items="editorialLists"
                  item-text="name"
                  item-value="id"
                  v-model="item.target_list_id"
                />
              </template>

              <template v-slot:item.mobile_only="{ item }">
                <div class="checkbox-cell-center">
                  <v-checkbox
                    class="ma-0 pa-0"
                    dense
                    hide-details
                    v-model="item.mobile_only"
                  />
                </div>
              </template>

              <template v-slot:item.enabled="{ item }">
                <div class="checkbox-cell-center">
                  <v-checkbox
                    class="ma-0 pa-0"
                    dense
                    hide-details
                    v-model="item.enabled"
                  />
                </div>
              </template>

              <template v-slot:item.timeout_seconds="{ item }">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  v-model.number="item.timeout_seconds"
                />
              </template>

              <template v-slot:item.response_delay_seconds="{ item }">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  v-model.number="item.response_delay_seconds"
                />
              </template>

              <template v-slot:item.retry_delay_seconds="{ item }">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  v-model.number="item.retry_delay_seconds"
                />
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn x-small color="primary" @click="saveRow(item)">
                  {{ $t("automazione-save-row") }}
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import automazione from "../../apis/automazione";
import editorial from "../../apis/editorial";

export default {
  data() {
    return {
      loading: false,
      assistants: [],
      editorialLists: [],
      headers: [
        { text: this.$t("automazione-operator-name"), value: "name", sortable: true },
        { text: this.$t("automazione-operator-list"), value: "target_list_id", sortable: false },
        {
          text: this.$t("automazione-operator-mobile-only"),
          value: "mobile_only",
          sortable: false
        },
        {
          text: this.$t("automazione-operator-timeout"),
          value: "timeout_seconds",
          sortable: false
        },
        {
          text: this.$t("automazione-operator-response-delay"),
          value: "response_delay_seconds",
          sortable: false
        },
        {
          text: this.$t("automazione-operator-retry-delay"),
          value: "retry_delay_seconds",
          sortable: false
        },
        {
          text: this.$t("automazione-operator-enabled"),
          value: "enabled",
          sortable: false
        },
        { text: "", value: "actions", sortable: false, align: "right" }
      ]
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loading = true;
      await Promise.all([this.fetchSetup(), this.fetchEditorialLists()]);
      this.loading = false;
    },

    fetchSetup() {
      return automazione.fetchSetup().then(result => {
        this.assistants = result.assistants.map(i => Object.assign({}, i));
      });
    },

    fetchEditorialLists() {
      return editorial.fetchListsNames({
        filters: { archived: false, container: 1 }
      }).then(result => {
        this.editorialLists = result;
      });
    },

    saveRow(item) {
      automazione.saveAssistant(item).then(() => {
        this.fetchSetup();
      });
    }
  }
};
</script>

<style scoped>
.checkbox-cell-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}
</style>
